import classNames from 'classnames';
import { useAppSelector } from 'hooks/useAppSelector';
import { FormattedMessage } from 'react-intl';
import { QuoteIcon } from 'routes/essential-workspace/components/quote-status/icon';
import { EssentialWorkflowStatus } from 'routes/essential-workspace/state/model';
import { selectIsBuySgSellsTradeWay } from 'state/uiPanelState/sidePanelUi/sidePanelUi.selectors';

import './style.scss';

function getBadgeColorByStatus(status: EssentialWorkflowStatus, isBuySgSellsTradeWay?: boolean) {
  switch (status) {
    case 'not-ready':
      return 'badge-default text-secondary';
    case 'ready':
    case 'price-in-progress':
      return 'badge-discreet-primary';
    case 'price-rejected':
      return 'badge badge-danger';
    case 'price-expired':
      return 'badge-discreet-warning';
    case 'priced':
      return isBuySgSellsTradeWay ? 'badge-outline-buy' : 'badge-outline-sell';
  }
}

export function QuoteBadge({
  formId,
  status,
  className,
}: {
  status: EssentialWorkflowStatus;
  formId: string;
  className?: string;
}) {
  const isBuy = useAppSelector(state => selectIsBuySgSellsTradeWay(state, formId));
  const badgeColor = getBadgeColorByStatus(status, isBuy);

  return (
    <div className={classNames('badge rounded-pill flex-x pe-1 gap-1', badgeColor, className)}>
      <QuoteBadgeLabel status={status} />
      <QuoteIcon status={status} size="sm" />
    </div>
  );
}

function QuoteBadgeLabel({ status }: { status: EssentialWorkflowStatus }) {
  switch (status) {
    case 'not-ready':
      return <FormattedMessage id="sidePanel.quoteStatus.notReady" />;
    case 'ready':
      return <FormattedMessage id="sidePanel.quoteStatus.ready" />;
    case 'price-in-progress':
      return <FormattedMessage id="sidePanel.quoteStatus.inProgress" />;
    case 'price-rejected':
      return <FormattedMessage id="sidePanel.quoteStatus.rejected" />;
    case 'price-expired':
      return <FormattedMessage id="sidePanel.quoteStatus.Expired" />;
    case 'priced':
      return <FormattedMessage id="sidePanel.quoteType.shortIndicative" />;
    default:
      return null;
  }
}
